import gql from 'graphql-tag';

import { avatarFragment } from './avatar-fragment';

export const userProfileQuery = gql`
  query UserProfile {
    me {
      ...AvatarFragment
      id
      displayName
      firstName
    }
  }

  ${avatarFragment}
`;

// profile plus information about user's
// active games and membership status
export const userStatusInfoQuery = gql`
  query UserStatusInfo {
    me {
      id
      displayName
      isWaybetterMember
      isTrial(product: waybetter)
      email
      firstName
      lastName
      playerPlans {
        edges {
          id
          name
          phase
          level
        }
      }
      memberships {
        edges {
          subscriptionId
          paymentPlanId
          offerId
        }
      }
      gameList(falkor: { search: { scopes: [unfinished] } }) {
        edges {
          id
          title
        }
      }
    }
  }
`;
